import { Component, OnInit } from '@angular/core';
import { CardSelectionService, SelectedCard } from '../shared/card-selection.service';
import { MatSidenav } from '@angular/material/sidenav';

@Component({
  selector: 'em-card-pattern-preview',
  templateUrl: './card-pattern-preview.component.html',
  styleUrl: './card-pattern-preview.component.css'
})
export class CardPatternPreviewComponent implements OnInit {
  rightSidenav: MatSidenav;

  selectedCard: SelectedCard | null = null;

  constructor(private cse: CardSelectionService) {}

  ngOnInit(): void {
   this.cse.selectedCard$.subscribe(card => {
      this.selectedCard = card;
    });
  }

  closePreview(): void {
    this.cse.clear();
  }

}
